/**
 * Admin User types for Admin Portal
 */

export type AdminUserStatus = 'active' | 'disabled';

export type AdminUserRole = 'super_admin' | 'support' | 'investigator';

export interface AdminUser {
  id: string;
  adminId: string; // Display ID like MS-84321
  name?: string;
  firstName?: string;
  lastName?: string;
  email: string;
  avatar?: string;
  role: AdminUserRole;
  status: AdminUserStatus;
  lastLogin?: Date;
  lastLoginText?: string;
  createdAt?: Date;
  createdAtText?: string;
}

export interface AdminUserFilter {
  role?: AdminUserRole | 'all';
  status?: AdminUserStatus | 'all';
  search?: string;
}

export interface PaginatedAdminUsers {
  data: AdminUser[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export const adminUserRoleLabels: Record<AdminUserRole, string> = {
  super_admin: 'Super Admin',
  support: 'Support',
  investigator: 'Investigator',
};

export const adminUserStatusLabels: Record<AdminUserStatus, string> = {
  active: 'Active',
  disabled: 'Disabled',
};

